"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInput = void 0;
var React = require("react");
require("./PhoneNumberInput.css");
require("react-intl-tel-input/dist/main.css");
require("libphonenumber-js-utils");
var react_intl_tel_input_1 = require("react-intl-tel-input");
var AllCountries_1 = require("react-intl-tel-input/dist/components/AllCountries");
var getCountryISO3 = require("country-iso-2-to-3");
var player_textbox_1 = require("player-textbox");
var PhoneNumberInput = (function (_super) {
    __extends(PhoneNumberInput, _super);
    function PhoneNumberInput(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeCountries = _this.initializeCountries.bind(_this);
        _this.getCountryByUserBrowser = _this.getCountryByUserBrowser.bind(_this);
        _this.sanitizePhoneValue = _this.sanitizePhoneValue.bind(_this);
        _this.notifyParentAboutChange = _this.notifyParentAboutChange.bind(_this);
        _this.handleIntlTelInputChange = _this.handleIntlTelInputChange.bind(_this);
        _this.handleCountryChange = _this.handleCountryChange.bind(_this);
        _this.handleTextBoxChange = _this.handleTextBoxChange.bind(_this);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.initializeCountries(_this.props.countryLocalizations);
        _this.isPhoneCountryCodeSelectorVisible = !!props.isPhoneCountryCodeSelectorVisible;
        var value = _this.isPhoneCountryCodeSelectorVisible ? _this.sanitizePhoneValue(props.value) : {
            phoneNumber: props.value && props.value.phoneNumber,
            countryCode: props.value && props.value.countryCode
        };
        _this.state = {
            phoneNumber: value.phoneNumber,
            country: _this.phoneCodeCountryMap.get(value.countryCode) || _this.getCountryByUserBrowser() || _this.iso2CountryMap.get('us'),
            errorMessage: props.errorMessage,
            phoneNumberValid: !!!props.errorMessage
        };
        return _this;
    }
    PhoneNumberInput.prototype.initializeCountries = function (countryLocalizations) {
        var _this = this;
        this.countries = AllCountries_1.default.getCountries();
        this.phoneCodeCountryMap = new Map();
        this.iso2CountryMap = new Map();
        this.countriesData = [];
        var localizationMap = new Map();
        if (countryLocalizations) {
            countryLocalizations.forEach(function (x) {
                localizationMap.set(x.iso3.toUpperCase(), x);
            });
        }
        this.countries.forEach(function (x) {
            var localization = localizationMap.get((getCountryISO3(x.iso2.toUpperCase()) || "").toUpperCase());
            x.name = (localization && localization.name) || x.name;
            _this.phoneCodeCountryMap.set(parseInt(x.dialCode), x);
            _this.iso2CountryMap.set(x.iso2, x);
            _this.countriesData.push([x.name, x.iso2, x.dialCode]);
        });
    };
    PhoneNumberInput.prototype.getCountryByUserBrowser = function () {
        var languageParts = window.navigator.language.split("-");
        if (languageParts.length < 2) {
            return undefined;
        }
        var country = this.iso2CountryMap.get(languageParts[1].toLowerCase());
        return country;
    };
    PhoneNumberInput.prototype.sanitizePhoneValue = function (value) {
        var parsedCountry = this.phoneCodeCountryMap.get((value && value.countryCode)) || (this.state && this.state.country);
        var parsedPhone = (value && value.phoneNumber) || "";
        if (parsedPhone[0] === "+") {
            var phoneStart = "";
            var i;
            for (i = 1; i < parsedPhone.length; i++) {
                phoneStart += parsedPhone[i];
                var phoneStartInt = parseInt(phoneStart);
                if (this.phoneCodeCountryMap.has(phoneStartInt)) {
                    parsedCountry = this.phoneCodeCountryMap.get(phoneStartInt);
                    parsedPhone = parsedPhone.substring(i + 1);
                    break;
                }
            }
        }
        return {
            countryCode: parseInt((parsedCountry && parsedCountry.dialCode) || null),
            phoneNumber: parsedPhone
        };
    };
    PhoneNumberInput.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.value || (this.props.value && (this.props.value.phoneNumber != prevProps.value.phoneNumber
            || this.props.value.countryCode != prevProps.value.countryCode))) {
            if (this.isPhoneCountryCodeSelectorVisible) {
                var sanitized_1 = this.sanitizePhoneValue(this.props.value);
                this.setState({
                    country: this.countries.find(function (x) { return x.dialCode == "+" + sanitized_1.countryCode; }) || this.state.country,
                    phoneNumber: sanitized_1.phoneNumber
                });
            }
            else {
                this.setState({
                    phoneNumber: this.props.value.phoneNumber || ""
                });
            }
        }
        if (this.props.errorMessage && prevProps.errorMessage !== this.props.errorMessage) {
            this.setState({
                errorMessage: this.props.errorMessage,
            });
        }
    };
    PhoneNumberInput.prototype.notifyParentAboutChange = function (value) {
        if (this.props.onChange) {
            this.props.onChange(value, this.props.tag);
        }
    };
    PhoneNumberInput.prototype.handleTextBoxChange = function (value) {
        var _this = this;
        this.setState({
            phoneNumber: value,
            errorMessage: ''
        }, function () {
            _this.notifyParentAboutChange({
                phoneNumber: _this.state.phoneNumber,
                phoneNumberValid: undefined,
                countryCode: undefined,
            });
        });
    };
    PhoneNumberInput.prototype.handleIntlTelInputChange = function (isValid, phoneNumber, country) {
        var _this = this;
        isValid = this.validatePhoneNumberExplicitly(isValid, phoneNumber, country.dialCode);
        var sanitized = this.sanitizePhoneValue({
            phoneNumber: phoneNumber,
            countryCode: parseInt(country.dialCode)
        });
        this.setState({
            phoneNumber: sanitized.phoneNumber,
            country: country,
            errorMessage: '',
            phoneNumberValid: !!isValid,
        }, function () {
            _this.notifyParentAboutChange({
                phoneNumber: _this.state.phoneNumber,
                phoneNumberValid: _this.state.phoneNumberValid,
                countryCode: parseInt(_this.state.country.dialCode),
            });
        });
    };
    PhoneNumberInput.prototype.handleCountryChange = function (_, country) {
        var intlTelInputUtils = window['intlTelInputUtils'];
        var isValid = intlTelInputUtils ? intlTelInputUtils.isValidNumber(this.state.phoneNumber, country.iso2) : this.state.phoneNumberValid;
        this.handleIntlTelInputChange(isValid, this.state.phoneNumber, country);
    };
    PhoneNumberInput.prototype.validatePhoneNumberExplicitly = function (isValid, phoneNumber, countryCode) {
        if (!isValid && countryCode == "64") {
            var validPrefixes = ["029", "027", "29", "27"];
            return validPrefixes.some(function (prefix) { return phoneNumber.startsWith(prefix); }) && (phoneNumber.length === 11 || phoneNumber.length === 10);
        }
        return isValid;
    };
    PhoneNumberInput.prototype.handleOnBlur = function () {
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };
    PhoneNumberInput.prototype.renderAsTextbox = function (props) {
        return (React.createElement(player_textbox_1.Textbox, __assign({}, props, { value: this.state.phoneNumber, errorMessage: this.state.errorMessage, onChange: this.handleTextBoxChange, onBlur: this.handleOnBlur })));
    };
    PhoneNumberInput.prototype.renderWithCountryCodeSelector = function (props) {
        var id = props.id || props.tag;
        return (React.createElement("div", { "data-tag": props.tag, className: "p-textbox form-row " + (props.isRequired && "is-required") },
            React.createElement("div", null,
                props.showLabel && (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: id, className: "with-label p-t-grey40 p-m-v-sm" }, props.label),
                    props.isRequired && React.createElement("span", { className: "p-t-error50" }, "*"))),
                React.createElement("div", null,
                    React.createElement(react_intl_tel_input_1.default, { fieldId: id, value: this.state.phoneNumber, countriesData: this.countriesData, defaultCountry: this.state.country.iso2, containerClassName: "intl-tel-input phone-number-input full-width with-icons", inputClassName: "p-textbox-input p-bc-grey40 p-bg-hv-white p-bc-f-blue50 row-1 " + (this.state.errorMessage && "is-invalid p-b-error p-bc-error50"), onPhoneNumberChange: this.handleIntlTelInputChange, onPhoneNumberBlur: this.handleOnBlur, onSelectFlag: this.handleCountryChange, preferredCountries: [], separateDialCode: true }),
                    this.state.errorMessage &&
                        React.createElement("span", { className: "error p-t-error50 p-m-t-sm", role: "alert" }, this.state.errorMessage)))));
    };
    PhoneNumberInput.prototype.render = function () {
        var _a = this.props, key = _a.key, value = _a.value, errorMessage = _a.errorMessage, onChange = _a.onChange, onBlur = _a.onBlur, props = __rest(_a, ["key", "value", "errorMessage", "onChange", "onBlur"]);
        return (React.createElement("div", { key: key }, this.isPhoneCountryCodeSelectorVisible ?
            this.renderWithCountryCodeSelector(props)
            :
                this.renderAsTextbox(props)));
    };
    PhoneNumberInput.defaultProps = {
        onChange: Function,
        onBlur: Function,
    };
    return PhoneNumberInput;
}(React.Component));
exports.PhoneNumberInput = PhoneNumberInput;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PhoneNumberInput"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/.tmp/PhoneNumberInput/PhoneNumberInput.js
// module id = 295
// module chunks = 0 1